
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#00DCF7","fill-rule":"nonzero","d":"M13.16 15.07l-1.93-.58a.57.57 0 01-.38-.55.54.54 0 01.51-.56h1.21c.193 0 .383.052.55.15a.33.33 0 00.43 0l.51-.48a.347.347 0 000-.52 2.578 2.578 0 00-1.37-.53v-1a.35.35 0 00-.35-.35h-.68a.35.35 0 00-.35.35v1a1.91 1.91 0 00-1.83 1.93 2 2 0 001.36 1.87l1.93.58c.23.078.384.297.38.54a.537.537 0 01-.137.39.536.536 0 01-.373.18h-1.21a1.102 1.102 0 01-.55-.16.36.36 0 00-.44 0l-.5.48a.347.347 0 000 .52c.39.296.86.467 1.35.49v1.05c.005.19.16.34.35.34h.68c.19 0 .345-.15.35-.34v-1a1.91 1.91 0 001.83-1.94 2.001 2.001 0 00-1.36-1.86h.02z"}}),_c('rect',{attrs:{"width":"5.5","height":"1.38","x":"6.5","y":"3.75","fill":"#5CE8AD","fill-rule":"nonzero","rx":".34"}}),_c('rect',{attrs:{"width":"5.5","height":"1.38","x":"6.5","y":"6.5","fill":"#5CE8AD","fill-rule":"nonzero","rx":".34"}}),_c('path',{attrs:{"fill":"#00DCF7","fill-rule":"nonzero","d":"M14.58 1v6.42h5.67V5.58z"}}),_c('path',{attrs:{"stroke":"#000","d":"M19.64 5.21L16 1.61A2.057 2.057 0 0014.58 1H5.81a2.07 2.07 0 00-2.06 2.07v17.87A2.06 2.06 0 005.81 23h12.38a2.06 2.06 0 002.06-2.06V6.67a2.078 2.078 0 00-.61-1.46h0z"}}),_c('path',{attrs:{"stroke":"#000","d":"M19.79 7.42H15a.71.71 0 01-.71-.71V1.46h0"}})])])
          )
        }
      }
    